import { render, staticRenderFns } from "./cmp-portal.vue?vue&type=template&id=64ceb5cd&"
import script from "./cmp-portal.vue?vue&type=script&lang=js&"
export * from "./cmp-portal.vue?vue&type=script&lang=js&"
import style0 from "./cmp-portal.vue?vue&type=style&index=0&id=64ceb5cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cmp-portal.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports